import { Person } from '~/layers/forms/models'

export interface Insured extends Person {
  customerAsInsured: boolean | null
}

function load(model?: Partial<Insured> | null): Insured {
  const { allowCustomerAsInsured } = useContractConstraints()
  return {
    ...Person.load(model),
    customerAsInsured: model?.customerAsInsured ?? allowCustomerAsInsured,
  }
}

export const Insured = {
  load,
}
